const Handlebars = require("handlebars/runtime");
Handlebars.registerHelper("raw", function(options) {
  return options.fn(this);
});
module.exports = Handlebars;
